// Table.jsx

import { saveFile } from './FunctionsSaveFile';
import { loadStateFromJSON } from './FunctionsLoadFile';
import { loadTemplateFromGitHub } from './FunctionsLoadTemplate';
import React, { useRef, useImperativeHandle, forwardRef, useState } from 'react';

const Table = forwardRef(({ rows, setRows, columns, setColumns, listItems, setListItems, onReceiveSavedStyles }, ref) => {
    const [savedStyles, setSavedStyles] = useState({}); // Assuming savedStyles is part of state in Table.jsx
    const fileInputRef = useRef(null);

    const handleUploadClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    // Then modify the handleUploadClickTemplate function:
    const handleUploadClickTemplate = () => {
        loadTemplateFromGitHub({
            setRows,
            setColumns,
            setListItems,
            onReceiveSavedStyles
        });
    };

    // Expose handleReceiveSavedStylesInTable to parent component
    useImperativeHandle(ref, () => ({
        handleReceiveSavedStylesInTable(data) {
            console.log("Table received savedStyles:", data);
            setSavedStyles(data); // Update savedStyles state with the passed data
        }
    }));

    return (
        <div>
            <div>
                <button
                    id="buttonSaveFile"
                    onClick={() => saveFile(rows, columns, listItems, savedStyles)} // Pass savedStyles here
                    style={{ display: 'none' }}
                >
                    Save File
                </button>

                <button
                    id="buttonLoadFile"
                    onClick={handleUploadClick}
                    style={{ display: 'none' }}
                >
                    Load File TABLE
                </button>
                <button
                    id="buttonLoadTemplate"
                    onClick={handleUploadClickTemplate}
                    style={{ display: 'none' }}
                >
                    Load Template File TABLE
                </button>
                <input
                    type="file"
                    accept=".onewriter,.json"
                    onChange={(event) =>
                        loadStateFromJSON(event, {
                            setRows,
                            setColumns,
                            setListItems,
                            onReceiveSavedStyles // Pass callback to receive savedStyles
                        })
                    }
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                />
            </div>
        </div>
    );
});

export default Table;
